import { TABS } from '../constants/tabs';
const isTabValid = tab => typeof tab === 'string' && Object.values(TABS).includes(tab);
export const getSanitizedTab = tab => isTabValid(tab) ? tab : TABS.COMMENTS;